import { createContext } from "react";
import { AjusteCategoria, AjusteVariacao, CatalogoUnico, DescontoProgressivo } from "../../types/Catalogo";
import { Categoria } from "../../types/Categoria";
import { Intermediadores } from "../../types/Configuracoes";
import ListaDePreco from "../../types/ListaDePreco";

export type CatalogoContextType = {
  catalogo: CatalogoUnico;
  setCatalogo: React.Dispatch<React.SetStateAction<CatalogoUnico>>;
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  outrosUsuarios: { email: string; id: string }[];
  listasDePrecos: ListaDePreco[];
  empresaIntermediadores: Intermediadores | undefined;
  setOutrosUsuarios: React.Dispatch<
    React.SetStateAction<{ email: string; id: string }[]>
  >;
  descontosProgressivos: DescontoProgressivo[];
  setDescontosProgressivos: React.Dispatch<React.SetStateAction<DescontoProgressivo[]>>;
  ajustesCategoria: AjusteCategoria[];
  setAjustesCategoria: React.Dispatch<React.SetStateAction<AjusteCategoria[]>>;
  ajustesVariacao: AjusteVariacao[];
  setAjustesVariacao: React.Dispatch<React.SetStateAction<AjusteVariacao[]>>;
  categorias: Categoria[];
  salvarCatalogo: () => Promise<string>;
  removerCatalogo: () => Promise<void>;
  init: () => Promise<void>;
};

export const CatalogoContext = createContext<CatalogoContextType>(null!);
